import { useEffect, useRef } from "react"
import { useAiTeammateContext, useSendMessageContext } from "../../hooks/context"
import useFetchMessages from "../../hooks/fetch-messages"
import useMinuteTicker from "../../hooks/minute-ticker"
import AiTeammateMessage from "../message"
import AiTeammateNoMessage from "../no-message"
import AiTeammateThinking from "../thinking"
import "./style.scss"

function AiTeammateMessagesPanel() {
  const initialRender = useRef(true)
  const panelRef = useRef(null)
  const { threadId, messages, error } = useAiTeammateContext()
  // Using a ticker to refresh the time of the messages every minute, since we are displaying relative times
  const { lastTickTime, startTicker, stopTicker } = useMinuteTicker()
  const { hasMessages, isFetchingMessages, fetchMessages } = useFetchMessages()
  const { isSendingMessage } = useSendMessageContext()

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false

      if (threadId) {
        fetchMessages()
      }
    }
  }, [threadId, fetchMessages])

  useEffect(() => {
    if (hasMessages) {
      startTicker()
    }

    return () => {
      stopTicker()
    }
  }, [hasMessages, startTicker, stopTicker])

  useEffect(() => {
    const panel = panelRef.current
    if (panel) {
      panel.scrollTo({
        top: panel.scrollHeight,
        behavior: "smooth",
      })
    }
  }, [messages, isSendingMessage])

  return <div className="ai-teammate-messages-panel" ref={panelRef}>
    {!hasMessages && !isFetchingMessages && <AiTeammateNoMessage />}
    {hasMessages && messages.map((message) => <AiTeammateMessage key={`message-${message.id}`} message={message} messageTimeRefresher={lastTickTime} />)}
    {error && <AiTeammateMessage
      message={{
        role: "assistant",
        error,
      }}
      messageTimeRefresher={lastTickTime}
    />}
    {isSendingMessage && <AiTeammateThinking />}
  </div>
}

export default AiTeammateMessagesPanel
